module.exports = __webpack_public_path__ + "img/logo-parsyl-icon.eca69886.svg";